"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNewEnrollmentId = void 0;
/**
 * @param {EnrollmentStepsApi} enrollmentStepsClient
 * @param {() => string} getXCLEARCorrelationInfo
 * @return {*}  {Promise<EnrollmentCreated>}
 */
exports.createNewEnrollmentId = async (enrollmentStepsClient, getXCLEARCorrelationInfo, suppressLogs = false) => {
    if (!suppressLogs)
        console.warn('This method creates a real record in the database and should only be used temporarily');
    return enrollmentStepsClient.startEnrollment({
        xCLEARCorrelationInfo: getXCLEARCorrelationInfo(),
        planSelectionCommand: {
            plan: 'tpc-enroll-5-clear-free-bundle-plan',
        },
    });
};
//# sourceMappingURL=create-new-enrollment.js.map